import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { from, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DocPopupTypes } from 'src/app/core/models/dialog.models';
/* import { FileTypes } from 'src/app/core/models/doc-file.models'; */
import { EndpointName } from 'src/app/core/models/endpoints.models';
import { APIService } from 'src/app/core/services/api.service';
import { PopupService } from 'src/app/core/services/popup.service';

@Component({
  selector: 'doc-file-uploader-dialog',
  templateUrl: 'file-uploader-dialog.component.html',
  styleUrls: ['file-uploader-dialog.component.scss']
})

export class DocFileUploaderComponentDialog implements OnInit, OnDestroy {
  private onDestroyed$ = new Subject();
  allowedTypes: string[] = ['png', 'bmp', 'jpg', 'jpeg', 'txt', 'ppt', 'pptx', 'doc', 'docx', 'pdf', 'xls', 'xlsx', 'mp4', '3gp', 'mpeg4', 'mov', 'mkv', 'avi'];
  multi = false;
  files: {
    [filename: string]: UploadedFile
  } = {};
  uploadResponse: any;

  constructor(
    private apiService: APIService,
    public dialogRef: MatDialogRef<DocFileUploaderComponentDialog>,
    private popupService: PopupService,
    
    @Inject(MAT_DIALOG_DATA) private data: any
  ) { }

  ngOnInit() { }

  onFileSelected(event) {
    const newFiles = event.target.files;
    this.newUpload(newFiles[0]);
  }


  newUpload(file){
    let formdata = new FormData();
    if(this.fileType(file?.name)){
      this.files[file.name] = file;      
      formdata.append('doc', file);
      formdata.append('filename', file?.name);

      this.apiService.post(EndpointName.newDocumentUpload, formdata, { type: this.data.type })
      .pipe(takeUntil(this.onDestroyed$))
      .subscribe(res => {
        this.uploadResponse = res;
        this.files[file.name].progress = 100;
        this.files[file.name].uploaded = true;
        this.dialogRef.close(res);
      })
    }else {        
      this.popupService.openDialog({
        type: DocPopupTypes.error,
        message: "ok",
        buttonText: "ok"
      })
      this.dialogRef.close();
    }
  }

  getUrls(newFiles) {
    newFiles = Object.values(newFiles);  
    let data = {};
    let validType = 
    newFiles.forEach(f => {           
      this.files[f.name] = f;
      if(this.fileType(f.name)){
        data[f.name] = {
          name: f.name,
          type: f.type
        }
      }else {        
        this.popupService.openDialog({
          type: DocPopupTypes.error,
          message: "",
          buttonText: "Ok"
        })
        this.closeDialog();
      }
    });
    this.apiService.post(EndpointName.getUploadUrlGenerator, data, { type: this.data.type })
      .pipe(takeUntil(this.onDestroyed$))
      .subscribe(urls => {
        const generatedUrls = urls.data.urls;
        Object.keys(generatedUrls).forEach(i => {
          this.files[i]['headers'] = generatedUrls[i].headers;
          this.files[i]['path'] = generatedUrls[i].path;
          this.files[i]['url'] = generatedUrls[i].url;
          this.uploadFile(this.files[i]);
        });
      })
  }

  uploadFile(fileDetails: UploadedFile) {
    this.files[fileDetails.name].progress = 0;
    this.files[fileDetails.name].uploaded = false;
    this.apiService.fileUpload(fileDetails.url, fileDetails, fileDetails.headers)
      .pipe(takeUntil(this.onDestroyed$))
      .subscribe(
        r => { },
        (error) => { this.files[fileDetails.name].error = true },
        () => {
          this.files[fileDetails.name].progress = 100;
          this.files[fileDetails.name].uploaded = true;
        }
      )
  }

  fileType(filename:string){
    var a = filename.split(".");
    if( a.length === 1 || ( a[0] === "" && a.length === 2 ) ) {
        return "";
    }
    return this.allowedTypes.includes(a.pop());
  }

  removeFile(name) {
    delete this.files[name];
  }

  getFilesArray() {
    return Object.values(this.files);
  }

  closeDialog() {
    // const uploadedFiles = Object.values(this.files).filter(f => f.uploaded);   
    this.dialogRef.close()
  }

  ngOnDestroy() {
    this.onDestroyed$.next();
    this.onDestroyed$.complete();
  }
}

export interface UploadedFile extends File {
  headers?: {};
  url?: string;
  path?: string;
  uploaded?: boolean;
  progress?: any;
  error?: boolean;
}
